import Row from './Row';
import Shelf from '../sprites/Shelf';
import Obstacle from '../sprites/Obstacle';
import {
  GAME_END_HEIGHT,
  GAME_LANE_HEIGHT,
  GAME_ROAD_HEIGHT,
  GAME_ROAD_WIDTH,
  GAME_GRID_SIZE,
  GAME_GRID_START_X,
} from '../../constants/AppConstants';

export default class RowShelves extends Row {
  constructor({ game, rowNum, shelfGroup }) {
    super({ game, rowNum });

    //
    this.obstacles = [];

    // add shelves
    this.createShelves(shelfGroup);
  }

  /*
  ====================================================================================
    SHELVES
  ====================================================================================
  */

  addRandomItem(item) {
    console.log('RowShelves.addRandomItem', item);
    const shelf = this.shelfs[this.game.rnd.integerInRange(0, this.shelfs.length - 1)];
    shelf.addRandomItem(item);
  }

  createShelves(shelfGroup) {
    let type = this.game.rnd.integerInRange(0, 3);
    switch (type) {
      case 0:
        this.createShelvesBB(shelfGroup);
        break;

      case 1:
        this.createShelvesBSB(shelfGroup);
        break;

      case 2:
        this.createShelvesBBB(shelfGroup);
        break;

      case 3:
        this.createShelvesBBCenter(shelfGroup);
        break;
    }
  }

  createShelvesBBCenter(shelfGroup) {
    let gx1 = this.game.rnd.integerInRange(3, 4);
    let shelf1 = new Shelf({ game: this.game, gx: gx1, size: 3, row: this, shelfType: shelfGroup[0] });
    shelf1.x = this.gridToPos(gx1).x;
    this.addChild(shelf1);

    let gx2 = gx1 + 3;
    let shelf2 = new Shelf({ game: this.game, gx: gx2, size: 3, row: this, shelfType: shelfGroup[1] });
    shelf2.x = this.gridToPos(gx2).x;
    this.addChild(shelf2);
    this.shelfs = [shelf1, shelf2];
    //
    this.createObstacles(1);
  }

  createShelvesBB(shelfGroup) {
    let gx1 = this.game.rnd.integerInRange(2, 3);
    let shelf1 = new Shelf({ game: this.game, gx: gx1, size: 3, row: this, shelfType: shelfGroup[0] });
    shelf1.x = this.gridToPos(gx1).x;
    this.addChild(shelf1);

    let gx2 = this.game.rnd.integerInRange(gx1 + 4, this.cellsInRow - 3);
    let shelf2 = new Shelf({ game: this.game, gx: gx2, size: 3, row: this, shelfType: shelfGroup[1] });
    shelf2.x = this.gridToPos(gx2).x;
    this.addChild(shelf2);
    this.shelfs = [shelf1, shelf2];
    //
    this.createObstacles(2);
  }

  createShelvesBSB(shelfGroup) {
    let gx1 = this.game.rnd.integerInRange(-1, 0);
    let shelf1 = new Shelf({ game: this.game, gx: gx1, size: 3, row: this, shelfType: shelfGroup[0] });
    shelf1.x = this.gridToPos(gx1).x;
    this.addChild(shelf1);

    let gx2 = this.game.rnd.integerInRange(gx1 + 3, gx1 + 5);
    let shelf2 = new Shelf({ game: this.game, gx: gx2, size: 1, row: this, shelfType: shelfGroup[1] });
    shelf2.x = this.gridToPos(gx2).x;
    this.addChild(shelf2);

    let gx3 = this.game.rnd.integerInRange(gx2 + 3, this.cellsInRow);
    let shelf3 = new Shelf({ game: this.game, gx: gx3, size: 3, row: this, shelfType: shelfGroup[2] });
    shelf3.x = this.gridToPos(gx3).x;
    this.addChild(shelf3);
    this.shelfs = [shelf1, shelf2, shelf3];
    //
    this.createObstacles(1);
  }

  createShelvesBBB(shelfGroup) {
    let gx1 = this.game.rnd.integerInRange(-1, 0);
    let shelf1 = new Shelf({ game: this.game, gx: gx1, size: 3, row: this, shelfType: shelfGroup[0] });
    shelf1.x = this.gridToPos(gx1).x;
    this.addChild(shelf1);

    let gx2 = this.game.rnd.integerInRange(gx1 + 4, gx1 + 6);
    let shelf2 = new Shelf({ game: this.game, gx: gx2, size: 3, row: this, shelfType: shelfGroup[1] });
    shelf2.x = this.gridToPos(gx2).x;
    this.addChild(shelf2);

    let gx3 = this.game.rnd.integerInRange(this.cellsInRow - 1, this.cellsInRow);
    let shelf3 = new Shelf({ game: this.game, gx: gx3, size: 3, row: this, shelfType: shelfGroup[2] });
    shelf3.x = this.gridToPos(gx3).x;
    this.addChild(shelf3);
    this.shelfs = [shelf1, shelf2, shelf3];
    //
    this.createObstacles(1);
  }

  /*
  ====================================================================================
    OBSTACLES
  ====================================================================================
  */

  createObstacles(amount = 1) {
    // find all free places
    let free = [];
    for (let i = 0; i < this.cellsInRow; i++) {
      if (this.cells[i] == 0) {
        free.push(i);
      }
    }

    // draw free place and place obstacle
    for (let i = 0; i < amount; i++) {
      let ind = this.game.rnd.integerInRange(0, free.length - 1);
      let gx = free.splice(ind, 1)[0];
      let type = this.game.rnd.integerInRange(0, 6);
      let obstacle = new Obstacle({ game: this.game, type: type, row: this });
      obstacle.x = this.gridToPos(gx).x;
      this.addChild(obstacle);
      this.obstacles.push(obstacle);

      // mark as full cell
      this.cells[gx] = 1;
    }
  }

  /*
  ====================================================================================
    OVERLOAD
  ====================================================================================
  */

  getColliders() {
    return []; //this.obstacles;
  }
}
